import comingSoonIMG from "../../images/image_coming_soon-min.png";
import comingSoonIMGFR from "../../images/image_coming_soon-fr-min.png";
import comingSoonIMGES from "../../images/image_coming_soon-es-min.png";
import {
    getSelectedPriceRange,
    getSelectedSegment,
    setVehiclesPrinceRange
} from "../../slices/vehicleSlice";
import {trackVehicleModelsUpdated} from "../GoogleTagManager.utils";

export function getActiveLanguage(language, supportedLanguages) {
    const langCode = language
    const activeLang = supportedLanguages.find(lang => lang.includes(langCode));
    return activeLang ? activeLang : supportedLanguages[0];
}

export function getVehicleName (modelCode, vehicle){

    return (vehicle.filter((vehicle) => vehicle.code === modelCode).map((vehicle) => vehicle.model))
}

export function getVehicleModelYear(modelCode, vehicle){
    return (vehicle.filter((vehicle) => vehicle.code === modelCode).map((vehicle) => vehicle.year))
}

export function getActiveLocaleImage(locale) {
    switch (locale) {
        case "es-US":
            return comingSoonIMGES;
        case "fr-CA":
            return comingSoonIMGFR;
        default:
            return comingSoonIMG;
    }
}

export function sendSegment(min,max,isActiveID,isActiveThumb,filteredSegment,dispatch,handleClose,filterGroup,minimumPrice,maximumPrice,thumb,setCounter) {
    if (min && max !== "") {
        isActiveThumb(true);
        setCounter(1);
    }

    if (min === minimumPrice && max === maximumPrice) {
        isActiveThumb(false);
        setCounter(0);
    }
    if (thumb === false && filteredSegment.length) {
        setCounter(filteredSegment.length);
    }
    dispatch(setVehiclesPrinceRange({minimumPrice: minimumPrice, maximumPrice:maximumPrice}))
    dispatch(getSelectedSegment(isActiveID));
    dispatch(getSelectedPriceRange([min, max]));
    handleClose();
    trackVehicleModelsUpdated(filterGroup);
}

export function getVehicleImage(modelCode, vehicle, locale){
    if (!!modelCode && !!vehicle){
        const vehicleData = (vehicle.filter((vehicle) => vehicle.code === modelCode) )[0]
        if (!!vehicleData){
            const {media} = vehicleData;
            let mediaToDisplay = null;
            if (!!media) {
                const mediaImage = Object.keys(media)[0];
                if (!!mediaImage) {
                    const angleShot = Object.keys(media[mediaImage])[0];
                    if (!!angleShot && typeof media[mediaImage][angleShot].url === "string" && media[mediaImage][angleShot].url.length > 0) {
                        mediaToDisplay = media[mediaImage][angleShot].url;
                    }
                } else {
                   return  getActiveLocaleImage(locale)
                }
            }
            return (mediaToDisplay)
        }
    }
}